export default __webpack_public_path__ + "static/media/Speech by Prof. Vidhya.d6a997fc.JPG";